import { Entity } from '..'
import { Transform, Type } from 'class-transformer'
import { Person } from '../persons'
import dayjs, { Dayjs } from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)

class UserMetadata {
  file: string
  path: string
}

export class User extends Entity {
  @Type(() => Person)
  person: Person;

  @Type(() => Dayjs)
  @Transform(({ value }) => value && dayjs(value), { toClassOnly: true })
  lastSeen?: Dayjs;

  @Type(() => UserMetadata)
  metadata: UserMetadata

  email: string
  disconnect: boolean
  active: boolean
  path: string

  get lastSeenLocal () {
    return this.formatDateDayjs(this.lastSeen)
  }

  get userIsOnline () {
    if (!this.lastSeen) return false

    const lastSeenLocal = this.lastSeenLocal
    if (!lastSeenLocal) return false

    // Crear ambos objetos desde el mismo formato para asegurar consistencia
    const nowStr = dayjs().tz('America/Santiago').format('YYYY-MM-DD HH:mm:ss')
    const lastSeenStr = lastSeenLocal.format('YYYY-MM-DD HH:mm:ss')

    // Crear objetos dayjs desde strings para comparación consistente
    const now = dayjs(nowStr)
    const lastSeen = dayjs(lastSeenStr)

    const diffInMinutes = now.diff(lastSeen, 'minute')

    return diffInMinutes < 1
  }
}
